import { withStyles } from '@material-ui/core/styles';
import React, { useState, useEffect } from 'react';
import * as v from '../../../helpers/validation';
import classnames from 'classnames';
// SERVICES
import { getApiUserById, putApiUser } from '../../../services/apiUser.service';
import { getClientList } from '../../../services/client.service';
import { DynamicForm } from '../../DynamicForm';
import { Button } from '@material-ui/core';
import { history } from '../../../helpers/history';

const styles = props => ({});

export const APIUserDetail = withStyles(styles)(props => {
  const { apiUserId } = props.match.params;
  
  const [apiUserFormData, setApiUserFormData] = useState(null);
  const [formError, setFormError] = useState('');
  const [clientList, setClientList] = useState([]);
  const [initAccountStatusId, setInitAccountStatusId] = useState(false);
  const [currentAccountStatusId, setCurrentAccountStatusId] = useState(null);
  
  useEffect(() => {

    getClientListAsync();
    getApiUserAsync();
  }, []);

  const getClientListAsync = async () => {
    let clients = await getClientList();
    clients = clients.map(c => ({
      value: c.id,
      label: `${c.name} ${c.code && `(${c.code})`}`,
    }));
    setClientList(clients);
  };

  const getApiUserAsync = async () => {
    try {
      let apiUserObj = await getApiUserById(apiUserId);
      const options = (apiUserObj.apiuserClients || []).map(c => ({ value: c.id, label: c.label }));
      setApiUserFormData({
        ...apiUserObj,
        accountStatusId: apiUserObj?.accountStatusId != null ? String(apiUserObj.accountStatusId) : apiUserObj?.accountStatusId,
        apiuserClients: options.map(o => o.value),
      });
      setInitAccountStatusId(apiUserObj.accountStatusId);
      setCurrentAccountStatusId(apiUserObj.accountStatusId);
    } catch (err) {
      setFormError('Error loading api user data');
    
    }
  };

  const clientOptions = clientList;

  const handleSave = async (formData) => {
    // Check if transitioning from inactive to active
    const isTransitioningToActive = initAccountStatusId !== 1 && currentAccountStatusId === 1;
    const isPasswordRequired = isTransitioningToActive;
    const hasPassword = formData.password && formData.password.trim().length > 0;

    if (isPasswordRequired && !hasPassword) {
      throw new Error('Password is required when activating an inactive user.');
    }

    // If password is provided, validate password strength
    if (hasPassword) {
      const passwordError = v.password()(formData.password);
      if (passwordError) {
        throw new Error(passwordError);
      }
    }

    return await putApiUser(formData);
  };

  const customActionsPanel = ({ isSubmitting, onSave, submitError, submitSuccess }) => (
    <div style={{ display: 'flex', alignItems: 'center', marginTop: 12 }}>
        {onSave && (
      <Button
        disabled={isSubmitting}
        variant="contained"
        style={{ backgroundColor: '#17c80d', color: '#fff', marginRight: 10 }}
        onClick={onSave}
      >
        {isSubmitting ? 'Saving…' : 'Save'}
      </Button>
      )}
      {!!submitError && <span style={{ marginLeft: 12, color: 'red' }}>{submitError}</span>}
      {!!submitSuccess && <span style={{ marginLeft: 12, color: 'green' }}>Success</span>}
    </div>
  );

  const apiUserInputs = [
    {
      inputType: 'gridcontainer',
      children: [
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'text',
              field: 'email',
              label: 'E-mail',
              validate: [v.required()],
              disabled: true,
            },
            {
              inputType: 'text',
              field: 'userName',
              label: 'Username',
              disabled: true,
              validate: [v.required()],
            },
            {
              inputType: 'select',
              field: 'accountStatusId',
              label: 'Account Status',
              options: [
                { value: '1', label: 'Active' },
                { value: '2', label: 'Inactive' },
              ],
              validate: [v.checkAccountStatus('Record Type must be `Active` or `Inactive`')],
              onChange: (value) => setCurrentAccountStatusId(parseInt(value)),
            },

          ],
        },
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'textarea',
              field: 'notes',
              label: 'Additional Notes',
            },
            {
                inputType: 'select',
                field: 'apiuserClients',
                label: 'API User Clients',
                options: clientOptions,
                isMulti: true,
              },
              ...(currentAccountStatusId === 1 ? [{
                inputType: 'text',
                field: 'password',
                label: 'Update Password',
                placeholder: initAccountStatusId !== 1 && currentAccountStatusId === 1
                  ? 'Password required (min 6 chars, 1 uppercase, 1 digit, 1 special char)'
                  : 'Enter a new password (min 6 chars, 1 uppercase, 1 digit, 1 special char)',
                validate: initAccountStatusId !== 1 && currentAccountStatusId === 1
                  ? [v.required(), v.password()]
                  : [v.password()],
              }] : []),
          ],
        },

      ],
    },
  ];


  return (
    <div className={classnames('grid-container')}>
      <DynamicForm
        inputs={apiUserInputs}
        data={apiUserFormData}
        mode={'EDIT'}
        onSave={handleSave}
        hideSubmitButton
        multiLocation
        redirectOnSuccess={'/users/api-users'}
        customActionsPanel={customActionsPanel}
      />
      <div>{formError}</div>
    </div>
  );
}); 